import { LeafAccordion } from "./accordion.component.js";
customElements.define("leaf-accordion", LeafAccordion);
export {
  LeafAccordion
};
//# sourceMappingURL=accordion.js.map
